import ReadMore from "stimulus-read-more"

export default class extends ReadMore {
    static targets = ["full", "content", "text"]
    connect() {
        this.open = false
        this.type = this.element.dataset.readMoreTypeValue
        this.readMoreText = this.element.dataset.readMoreMoreTextValue
        this.readLessText = this.element.dataset.readMoreLessTextValue
        if (this.hasContentTarget && this.hasFullTarget) {
            const contentChildNumber = this.contentTarget.children.length
            const fullChild = this.fullTarget.content.children
            Array.from(fullChild).forEach((child, index) => {
                if (index < contentChildNumber) return
                child.classList.add('extra')
                child.classList.add('hidden')
                child.style.opacity = 0
                child.style.transitionDelay = `${((index - contentChildNumber) + 1) * 50}ms`
                this.contentTarget.appendChild(child)
            })
        }
        super.connect()
    }

    totalHeight(items) {
        let totalSubItemHeight = 0
        Array.from(items).forEach(subItem => {
            const style = window.getComputedStyle(subItem)
            const height = subItem.offsetHeight
            const marginTop = parseFloat(style.marginTop)
            const marginBottom = parseFloat(style.marginBottom)
            totalSubItemHeight += height + marginTop + marginBottom
        })
        return totalSubItemHeight
      }

    toggle(event) {
        if (this.open === false) {
            this.show(event)
        } else {
            this.hide(event)
        }
    }

    show(event) {
        if (this.type === 'text') return super.show(event)
        this.open = true
        this.element.classList.add('expanded')
        this.contentTarget.style.height = this.totalHeight(this.contentTarget.children) + "px"
        const childrenWithExtra = Array.from(this.contentTarget.children).filter(child => child.classList.contains('extra'))
        childrenWithExtra.forEach((child, index) => 
            {
                child.style.transitionDelay = `${(index + 1) * 50}ms`
                child.classList.remove('hidden')
                setTimeout(() => { 
                    child.style.opacity = 1 
                }, 10)
            }
        )
        this.contentTarget.style.height = this.totalHeight(this.contentTarget.children) + "px"
        if (this.hasTextTarget) {
            this.textTarget.innerHTML = this.readLessText
        } else {
            event.target.innerHTML = this.readLessText
        }
        setTimeout(() => {
            this.contentTarget.style.height = "auto"
            childrenWithExtra.forEach((child) => 
                {
                    child.style.transitionDelay = ''
                }
            )
        }, 500)
    }

    hide(event) {
        if (this.type === 'text') return super.hide(event)
        this.open = false
        this.element.classList.remove('expanded')
        this.contentTarget.style.height = this.totalHeight(this.contentTarget.children) + "px"
        const childrenWithoutExtra = Array.from(this.contentTarget.children).filter(child => !child.classList.contains('extra'))
        const childrenWithExtra = Array.from(this.contentTarget.children).filter(child => child.classList.contains('extra'))
        childrenWithExtra.forEach((child) => {
            child.style.opacity = 0
        })
        this.contentTarget.style.height = this.totalHeight(childrenWithoutExtra) + "px"
        if (this.hasTextTarget) {
            this.textTarget.innerHTML = this.readMoreText
        } else {
            event.target.innerHTML = this.readMoreText
        }
        setTimeout(() => {
            childrenWithExtra.forEach(child => child.classList.add('hidden'))
            this.contentTarget.style.height = "auto"
        }, 500)
    }
}